import styled from 'styled-components'

export const Table = styled.table`
  border-collapse: separate;
  border-spacing: 0 10px;
  color: rgb(108, 117, 125);
  width: 100%;
  padding: 10px;
`

export const TheadRow = styled.tr`
  height: 34px;
`

export const TH = styled.th`
  border-bottom: 1px solid #000;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  line-height: 1;
  padding: 0 5px;
`
